import { render } from "./armada.vue?vue&type=template&id=5e1e3bc7"
import script from "./armada.vue?vue&type=script&lang=js"
export * from "./armada.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__